import { render, staticRenderFns } from "./settlementDocDetail.vue?vue&type=template&id=3ae3e56b&scoped=true"
import script from "./settlementDocDetail.vue?vue&type=script&lang=js"
export * from "./settlementDocDetail.vue?vue&type=script&lang=js"
import style0 from "./settlementDocDetail.vue?vue&type=style&index=0&id=3ae3e56b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae3e56b",
  null
  
)

export default component.exports